module.exports = __webpack_public_path__ + "static/bg01-7322e211933dd81edc0df6296bd38a12.jpg";